<template>
  <v-dialog
    persistent
    scrollable
    width="454"
    :value="true"
    @keydown.esc="$emit('close')"
  >
    <v-card class="px-6 py-4">
      <v-card-title class="px-0 py-0 mb-6">{{
        $t('filters.save_filter')
      }}</v-card-title>
      <v-text-field
        v-model="name"
        outlined
        dense
        counter
        :label="`${$t('filters.my_filter_name')}`"
        :maxlength="40"
      />
      <v-card-actions class="justify-end">
        <Button
          color="grey"
          plain
          :disabled="isLoading"
          :text="$t('common.button.cancel')"
          @click="handleCancel"
        />
        <Button
          plain
          color="blue"
          :loading="isLoading"
          :disabled="isLoading || !name"
          :text="$t('common.button.save')"
          @click="$emit('save', name)"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Button from '@/components/UI/Button'

import trackingMixin from '@/mixins/tracking/trackerMixin.vue'

export default {
  props: {
    isLoading: {
      typeof: Boolean,
      default: false,
    },
  },
  mixins: [trackingMixin],
  components: {
    Button,
  },
  data() {
    return {
      name: '',
    }
  },
  methods: {
    handleCancel() {
      this.trackFilterActions('my_filters.cancel_save')
      this.$emit('close')
    },
  },
}
</script>
